import { AppBar, Box, Button, Toolbar } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import "../styles.css";

const navLinkSx = {
  fontFamily: "Orbitron",
  letterSpacing: "1px",
};

export default function NavigationBar() {
  return (
    <AppBar
      position="fixed"
      color="transparent"
      elevation={0}
      sx={{
        p: 0,
        backgroundColor: "#1a1a1a",
        boxShadow: "none",
        borderBottom: "1px solid rgba(129, 203, 233, 0.15)",
      }}
    >
      <Toolbar>
        <Button variant="outlined" component={RouterLink} to="/" sx={navLinkSx}>
          Home
        </Button>
        <Box sx={{ flexGrow: 1 }} />
        {/* <Button
          variant="outlined"
          component={RouterLink}
          to="/blog"
          sx={{ ...navLinkSx, ml: 1 }}
        >
          Blog
        </Button> */}
      </Toolbar>
    </AppBar>
  );
}
